import Helper from './Helper';

class CVToggle {
  constructor() {
    this.cvToggle = document.querySelectorAll('.js-toggle-cv');
    if (this.cvToggle.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.cvToggle.forEach(toggle => {
      toggle.addEventListener('click', e => {
        Helper.toggleClass(toggle.parentNode, 'cv-open');
        Helper.slideToggle(toggle.previousElementSibling);
      });
    });
  }
}

export default CVToggle;
